//---- components ---------
//---- mixins -------------
import globalMixin from '../common/global-mixin.js';
//---- services -----------
import { ajaxService } from '@/app/services/http-client.js';
import NotificationService from "@/app/services/notification.js";
//---- other --------------
import appLogger from './app-logger.js';
import store from '../store/index.js';
import URL from '../common/URL.js';
//---- 3rd-parties --------
import VueApp from '@/main.js'

class ProjectHomeService {
  alreadygeneratingPdf = false;

  async openProject(reqData) {
    return ajaxService.post(URL.openProjectUrl, reqData)
  }

  generatePdf(reqData, caseNumber) {
    if (this.alreadygeneratingPdf)
      return NotificationService.info(VueApp.$t('error.printing.already-running'));
      
      NotificationService.info(VueApp.$t("label.printFileDownload"));
      this.alreadygeneratingPdf = true;
      ajaxService.getBinary(URL.generatePdfUrl, reqData)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', caseNumber + '.pdf');
        document.body.appendChild(link);
        link.click();
        this.alreadygeneratingPdf = false;
        window.URL.revokeObjectURL(url);
        NotificationService.info(VueApp.$t('label.printFileDownloaded'));
      });
  }

  async getSolutionsToPrint() {
    return ajaxService.post(URL.getSolutionsToPrintUrl);
  }

  isOnCaseDetail(response) {
    return response.data?.caseIds && response.data.caseIds.length > 0 && response.data.caseIds[0] > 0;
  }

  async verifyCaseDetail(response) {
    // if we're on case detail, get that data as well
    let caseDetailResponse = null;
    if (this.isOnCaseDetail(response)) {
      // scharette 2023-06-19: that true being passed as the last parameter might not be the best way
      //                       we would need to review that code. 
      caseDetailResponse = await this.solutionView(response.data.caseIds, null, true)
    }

    let onCaseDetail = false;
    store.dispatch("projectData/setCallCenterData", response.data);
    if (caseDetailResponse?.data && caseDetailResponse.data?.status != "no-case") {
        store.dispatch("projectData/updateSolutionView", caseDetailResponse.data);
        onCaseDetail = true;
    }
    if (response.data.currentLocale)
      store.dispatch("header/setLocale", response.data.currentLocale);

    return onCaseDetail;
  }

  // call this when the response from server is the result of a 
  // SearchAction.drawLayoutState call
  // 
  // this method will make the necessary followup calls to the 
  // server and redirect to the appropriate route if needed.
  async onCallCenterResponse(response) {
    if (response.data.status === "exception") {
      // session expired is already handled at the http-client level, 
      // so we just return the response
      if (response.data.key === "session-expired")
        return response;
      return Promise.reject(response.data)
    }

    // if we're on case detail, get that data as well
    if (this.isOnCaseDetail(response)) {
        if (!globalMixin.methods.safeRouterPush("/project-home"))
            await this.verifyCaseDetail(response);
        return;
    }

    store.dispatch("projectData/setCallCenterData", response.data);

    // if we're on authoring page, 
    // if (store.getters["projectData/states"].includes("case_mgnt")) {
    //   return response;
    // }

    //console.log("response.data.states: " + response?.data?.states);
    //console.log("store.getters[\"projectData/states\"]: " + store.getters["projectData/states"]);
    // if ((response?.data?.states || []).includes("case_compare")) {
    //   globalMixin.methods.safeRouterPush("/solution-compare");
    //   return response;
    // }

    if (!globalMixin.methods.safeRouterPush("/project-home"))
        store.dispatch("header/reload");
        
    return response
  }

  async callCenter(reqData) {
    try {
      const response = await ajaxService.post(URL.callcenterUrl, reqData)
      await this.onCallCenterResponse(response)
      return response;
    }
    catch {
      return {};
    }
  }

  async showCaseReadOnly(reqData) {
    const response = await this.loadCaseDetails(reqData)
    globalMixin.methods.safeRouterPush('/case-details')
    return response
  }

  async loadCaseDetails(reqData) {
    const response = await ajaxService.post(URL.callcenterUrl, reqData)
    await this.verifyCaseDetail(response)
    return response
  }

  showCase(reqData) {
    return ajaxService.post(URL.showcaseUrl, reqData)
  }

  showGDPR() {
    return ajaxService.get(URL.getGDPRInfoUrl)
  }

  switchLocale(localeCode) {
    return ajaxService.postWithParams(URL.switchLocaleUrl, { "chooseLocale": localeCode })
  }

  selectAllResults() {
    return ajaxService.post(URL.selectAllResultsUrl)
  }

  deselectAllResults() {
    return ajaxService.post(URL.deselectAllResultsUrl)
  }

  async callFreeTextSearch(freeTextQuery) {
    this.searchDataType = null;
    const response = await ajaxService.postFormData(URL.freeTextSearchUrl, { "freeText": freeTextQuery })
    await this.onCallCenterResponse(response)
    return response
  }

  async restore() {
    const response = await ajaxService.get(URL.restoreActionUrl)
    await this.onCallCenterResponse(response)
    return response
  }

  crmFormFeedback(reqData) {
    return ajaxService.post(URL.crmFormFeedbackUrl, reqData)
  }

  dsCrmFeedback(reqData) {
    return ajaxService.post(URL.dsCrmFeedback, reqData)
  }

  async callSearchCaseName(caseName) {
    this.searchDataType = "case";
    const response = await ajaxService.postWithParams(URL.searchCaseNameUrl, { "caseName": caseName })
    store.dispatch("projectData/solutionView", { caseId: response.data.caseIds[0] });
    return response;
  }

  async callExpertSearchSolutions() {
    const response = await ajaxService.post(URL.expertSearchSolutionsUrl)
    await this.onCallCenterResponse(response)
    return response
  }

  async getResultsByPage(pageNumber) {
    const response = await ajaxService.postData(URL.searchResultsNavigate, { navigationIndex: pageNumber });
    store.dispatch("projectData/setSearchResults", response.data)
    return response;
  }
  async resetProject() {
    const currentProfile = store.getters["projectData/currentProfile"];
    await this.switchProfile(currentProfile.id);
    await this.switchQuest(currentProfile.quests[0].id);
  }

  switchProfile(profileId) {
    var actionStartTime = new Date().getTime();
    return ajaxService.postWithParams(URL.selectProfileUrl,
      {
        "profile": profileId,
        "actionStartTime": actionStartTime,
        "actionCategory": "selectProfile"
      })
  }

  async switchQuest(questId) {
    var actionStartTime = new Date().getTime();
    const response = await ajaxService.postWithParams(URL.selectQuestUrl,
      {
        "questToSwitch": questId,
        "actionStartTime": actionStartTime,
        "actionCategory": "selectQuest"
      });

    await this.onCallCenterResponse(response);
    return response
  }

  callExpertViewAttributes(reqData) {
    return ajaxService.postData(URL.getExpertViewAttributesUrl, reqData);
  }

  callGivenAttribute(viewId, attribId) {
    if (!viewId)
      appLogger.logClientSideErrorWithStackToServer({ msg: "no view id provided to callGivenAttribute" })
    return ajaxService.postWithParams(URL.getGivenAttributeUrl,
      {
        "viewId": viewId,
        "attribId": attribId
      })
  }

  async callGuidedSearchInit() {
    const response = await ajaxService.post(URL.guidedSearchInitUrl)
    await this.onCallCenterResponse(response);
    return response
  }

  callGuidedSearch(params) {
    return ajaxService.postData(
      URL.guidedSearchUrl,
      params
    )
  }

  callUndecidedValue(params) {
    return ajaxService.postData(
      URL.selectUndecidedValueUrl,
      params
    )
  }

  callUndecidedAttribute(params) {
    return ajaxService.postData(
      URL.selectUndecidedAttributeUrl,
      params
    )
  }

  skipUndecidedAction(params) {
    return ajaxService.postData(
      URL.skipUndecidedUrl,
      params
    )
  }

  // silentRedirect is used so that if the solution was expired and is no longer visible by the user, we won't display an error, and 
  // we'll just go back to previous state
  async solutionView(caseId, action, silentRedirect) {
    const response = await ajaxService.postData(URL.viewCaseDetailsUrl, { caseId, action: action || "caseDetail", silentRedirect });
    const cases = response?.data?.cases || [];
    if (cases.length > 0 && cases[0]?.error)
      NotificationService.warn(cases[0]?.error);
    return response;
  }

  async backAction(state) {
    if (this.searchDataType == 'case') {
      const freeTextInputBox = document.getElementById('free-text-search-input');
      if (freeTextInputBox)
        freeTextInputBox.value = '';
    }
    const response = await this.backActionNoUpdate(state)
    await this.onCallCenterResponse(response)
    return response
  }

  async backActionNoUpdate(state) {
    return await ajaxService.postData(URL.previousUrl, { state })
  }

  searchFilter(params) {
    return ajaxService.postWithParams(
      URL.initSearchFilterUrl,
      params
    );
  }

  browseCasebaseBy(params) {
    return ajaxService.postWithParams(
      URL.browseCasebaseByUrl,
      params
    );
  }

  guidedToogleShowMoreLess(params) {
    return ajaxService.postData(
      URL.guidedToogleShowMoreLess,
      params
    );
  }

  searchComplete() {
    return ajaxService.post(URL.getSearchSummaryUrl);
  }

  exitSession(formData) {
    return ajaxService.post(URL.exitUrl, formData);
  }

  dsCloseInit(formData) {
    return ajaxService.post(URL.dsDetailsUrl, formData);
  }

  dsGetEscalate() {
    return ajaxService.post(URL.dsGetEscalateUrl);
  }

  dsEscalate(formData) {
    return ajaxService.post(URL.dsEscalateUrl, formData);
  }

  async resetSearchResults(formData) {
    const response = await ajaxService.post(URL.resetSearchUrl, formData)
    await this.onCallCenterResponse(response);
    return response
  }

  async removeBreadcrumbItem(id) {
    const response = await ajaxService.postWithParams(URL.removeBreadCrumbUrl, { id })
    await this.onCallCenterResponse(response);
    return response
  }

  editBreadcrumbItem(id) {
    return ajaxService.postWithParams(URL.editBreadCrumbUrl, { id });
  }

  async updateBreadcrumbItem(postData) {
    const response = await ajaxService.postWithParams(URL.updateBreadCrumbUrl, postData)
    await this.onCallCenterResponse(response);
    return response
  }

  getExternalSearchResultsByPage(postData) {
    return ajaxService.postData(
      URL.federatedSearchUrl,
      postData
    )
  }

  getCaseDetailsByNavigationIndex(navigationIndex) {
    return ajaxService.postData(
      URL.caseDetailsNavigateUrl,
      navigationIndex
    )
  }

  selectResult(caseId) {
    return ajaxService.getWithParams(URL.selectResultUrl, { caseId });
  }

  deselectResult(caseId) {
    return ajaxService.getWithParams(URL.deselectResultUrl, { caseId });
  }

  reloadProjectVersion() {
    return ajaxService.post(URL.reloadProjectVersionUrl);
  }

  //Ask Our Expert
  askOurExpert(requestData) {
    return ajaxService.postUrlEncodedData(URL.askExpertUrl, requestData);
  }

  // remove from favorites
  removeFromFavorites(requestData) {
    return ajaxService.postData(URL.removeFromFavoritesUrl, requestData)
  }

  //search initialize
  searchInitialize() {
    return ajaxService.get(URL.searchInitializeUrl)
  }

  //start casebase browser
  runBrowseCasebase() {
    return ajaxService.get(URL.runBrowseCasebaseUrl)
  }

  // custom1 result by page
  getCustomResultsByPage(requestData) {
    return ajaxService.postData(URL.customSolutionsNavigateActionUrl, requestData)
  }

  //get the bookmark url
  getBookmarkURL(requestData) {
    return ajaxService.postData(URL.generateBookmarkUrl, requestData)
  }
  // exceute bookmark url
  executeBookmark(reqData) {
    return ajaxService.postData(URL.executeBookmarkUrl, reqData)
  }

  onHomeLinkClicked() {
    return ajaxService.postData(URL.onHomeLinkClickedUrl)
  }
}

export default new ProjectHomeService();